import { useEffect, useState } from "react";
import { getAdminFinancials } from "../../services/ingroove/adminService";
import PageHeader from "../../components/common/PageHeader";
import FinancialStatCards from "../../components/ingroove/financials/FinancialStatCards";
import MonthlyRevenueChart from "../../components/ingroove/financials/MonthlyRevenueChart";
import TopHubsTable from "../../components/ingroove/financials/TopHubsTable";

const currentYear = new Date().getFullYear();
const yearOptions = Array.from({ length: 3 }, (_, i) => currentYear - i);

const Financials = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [year, setYear] = useState(currentYear);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      try {
        const res = await getAdminFinancials(year);
        setData(res);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [year]);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <PageHeader
          title="Financials"
          subtitle="Platform revenue, fees and hub payouts"
        />
        <select
          value={year}
          onChange={(e) => setYear(Number(e.target.value))}
          className="text-sm bg-bg-surface border border-border rounded-lg px-3 py-1.5 text-text-primary focus:outline-none focus:border-primary transition"
        >
          {yearOptions.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </div>

      {loading ? (
        <div className="space-y-6 animate-pulse">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <div
                key={i}
                className="bg-bg-surface border border-border rounded-xl h-24"
              />
            ))}
          </div>
          <div className="bg-bg-surface border border-border rounded-xl h-72" />
          <div className="bg-bg-surface border border-border rounded-xl h-64" />
        </div>
      ) : !data ? (
        <p className="text-text-muted text-sm">Failed to load financials.</p>
      ) : (
        <>
          <FinancialStatCards data={data} />
          <MonthlyRevenueChart data={data.monthlyRevenue} />
          <TopHubsTable hubs={data.topHubsByRevenue} />
        </>
      )}
    </div>
  );
};

export default Financials;
